var _regeneratorRuntime = require("/var/www/html/portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");
var _asyncToGenerator = require("/var/www/html/portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _require = require('./handlers'),
  handle200Res = _require.handle200Res,
  handleNon200Res = _require.handleNon200Res,
  handleErr = _require.handleErr;
var req = function req(uri, opts) {
  var on = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var thisArg = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var _kali = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  if (!thisArg) {
    thisArg = this;
  }
  var timeout = false,
    _timer;
  if (opts.timeout) {
    var duration = opts.timeout;
    _timer = window.setTimeout(function () {
      timeout = true;
      _res = {
        status: 'kali::timeout'
      };
      data = false;
      handleNon200Res.call(thisArg, _kali, _res, on);
    }, duration);
    console.log('timeout:', duration);
  }
  var _res;
  return fetch(uri, opts).then(function (res) {
    if (!timeout) {
      console.debug('kali::timout _timer cleared...');
      window.clearTimeout(_timer);
    } else {
      throw new Error("kali::timeout");
    }
    if (!res.ok) {
      try {
        res.json().then(handleNon200Res.bind(thisArg, _kali, res, on));
      } catch (err) {
        console.warn('json?');
        res.text().then(handleNon200Res.bind(thisArg, _kali, res, on));
      }

      // stop the promise chain!
      return false;
    }
    _res = res;
    return res.json();
  }).then(function (data) {
    if (!data) {
      return;
    }
    handle200Res.call(thisArg, _kali, _res, data, on);
  }).catch(function (err) {
    if (err.message === "kali::timeout") {
      return;
    }
    handleErr.call(thisArg, _kali, err, on);
  });
};
var reqSync = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(uri, opts) {
    var res, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!opts.timeout) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", console.error('opts.timeout sync calls are not supported by kali'));
          case 2:
            _context.next = 4;
            return fetch(uri, opts);
          case 4:
            res = _context.sent;
            _context.prev = 5;
            _context.next = 8;
            return res.json();
          case 8:
            data = _context.sent;
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](5);
            return _context.abrupt("return", {
              res: res,
              data: data,
              err: _context.t0
            });
          case 14:
            return _context.abrupt("return", {
              res: res,
              data: data,
              err: false
            });
          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 11]]);
  }));
  return function reqSync(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var usage = function usage() {
  console.log("\nasync:\nnew kali({opts...}).{get,post}(uri, {on...}, (thisArg=false));\nnew kali({opts...}).{get,post}Sync(uri, {on...}, (thisArg=false));\n\nsync:\nlet { res, data, err } = await new kali({opts...}).{get,post}(uri);\nlet { res, data, err } = await new kali({opts...}).{get,post}Sync(uri);\n");
};
var kali = function kali() {
  var _this = this;
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (typeof opts !== 'object') {
    return console.error(usage());
  }
  opts.method = 'GET';
  if (opts.body || opts.form) {
    opts.method = 'POST';
  }
  if (opts.method === 'POST') {
    if (typeof opts.headers !== 'object') {
      opts.headers = new Headers();
    }
    if (!(opts.headers instanceof Headers)) {
      console.debug('opts.headers converted to new Headers()');
      opts.headers = new Headers(opts.headers);
    }
    if (opts.body && typeof opts.body === 'object') {
      try {
        opts.body = JSON.stringify(opts.body);
        if (!opts.headers.has('content-type')) {
          opts.headers.set('content-type', 'application/json');
        }
      } catch (err) {
        console.error(err);
        return false;
      }
    }
    if (opts.form) {
      if (opts.form instanceof FormData) {
        opts.body = opts.form;
      }

      // TODO: convert to JSON 
      // TODO :and skip OPTIONS?
    }
  }
  if (opts.auth) {
    // TODO: auth
  }
  opts.query = opts.query || {};
  if (opts.query.XYZ) {
    // TODO: cols/delete/etc...
  }
  if (opts.headers) {
    console.log('headers:', opts.headers);
  }
  // console.log(opts);

  this.get = function (uri) {
    var on = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var thisArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    _this._uri = uri;
    _this._opts = opts;
    _this._on = on;
    _this._thisArg = thisArg;
    return req(uri, opts, on, thisArg, _this);
  };
  this.getSync = function (uri) {
    return reqSync(uri, opts);
  };
  this.post = function (uri) {
    var on = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var thisArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    _this._uri = uri;
    _this._opts = opts;
    _this._on = on;
    _this._thisArg = thisArg;
    if (opts.method !== 'POST') {
      opts.method = 'POST';
    }
    return req(uri, opts, on, thisArg, _this);
  };
  this.postSync = function (uri) {
    if (opts.method !== 'POST') {
      opts.method = 'POST';
    }
    return reqSync(uri, opts);
  };
  this.retry = function () {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
    if (duration < 1000) {
      console.warn('retry duration(ms) must be at least 1000');
      return;
    }
    window.setTimeout(function () {
      return _this[_this._opts.method.toLowerCase()](_this._uri, _this._on, _this._thisArg);
    }, duration);
  };
  this.create = function (uri) {
    var on = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var thisArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return _this.post(uri, Object.assign({}, opts, {
      mode: 'CREATE'
    }), on, thisArg);
  };
  this.update = function (uri) {
    var on = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var thisArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return _this.post(uri, Object.assign({}, opts, {
      mode: 'UPDATE'
    }), on, thisArg);
  };
  this.delete = function (uri) {
    var on = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var thisArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    uri += '&delete=1';
    uri = uri.replace('?&', '?');
    return _this.post(uri, Object.assign({}, opts, {
      mode: 'DELETE'
    }), on, thisArg);
  };
};

// convert obj from FormData{} to JSON{}
var formDataToJSONObj = function formDataToJSONObj(fd) {
  var obj = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;
  try {
    for (var _iterator = fd.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var d = _step.value;
      console.debug(d[0], d[1]);
      obj[d[0]] = d[1];
      if (d[0] === 'id' || ~d[0].indexOf('.id')) {
        obj[d[0]] = Number(d[1]);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  console.debug(obj);
  return obj;
};
module.exports = kali;